import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { Header } from "./components/musemi/Header";
import { Hero } from "./components/musemi/Hero";
import { WhatIsMusemi } from "./components/musemi/WhatIsMusemi";
import { Mission } from "./components/musemi/Mission";
import { Experience } from "./components/musemi/Experience";
import { CuratedMoments } from "./components/musemi/CuratedMoments";
import { Waitlist } from "./components/musemi/Waitlist";
import { Footer } from "./components/musemi/Footer";
import FAQ from "./pages/FAQ";

const Landing = () => {
  useEffect(() => {
    document.title = "Musemi — Shared Wardrobe. Endless Moments.";
  }, []);

  return (
    <div data-testid="landing-page" className="App bg-[#F6F2EC] text-[#2B2320] overflow-x-hidden">
      <Header />
      <main>
        <Hero />
        <WhatIsMusemi />
        <Mission />
        <Experience />
        <CuratedMoments />
        <Waitlist />
      </main>
      <Footer />
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#2B2320",
            color: "#F6F2EC",
            border: "none",
            borderRadius: 0,
            fontFamily: "'Inter', sans-serif",
            letterSpacing: "0.05em",
            fontSize: "0.75rem",
          },
        }}
      />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/faq" element={<FAQ />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
